export default __webpack_public_path__ + "static/media/analyze_report_4.54c23846.svg";